import Shape from './Shape';
import Coords from '../Util/Coords';

export default class Text extends Shape {

    constructor(p1) {
        super();
        this.point = p1;
        this.bounds = [0,0];
    }

    isText() {
        return true;
    }

    export() {
        return {
            id: this.id,
            type: 'text',
            layer: this.layer,
            point: this.point,
            props: this.props.export('text'),
        }
    }

    updateProp(key, value) {
        if (key === 'point') {
            this.point = value;
        }
    }

    isHover (point) {
        let distanceX = Math.abs(this.point[0] - point[0]);

        if (distanceX <=  this.bounds[0]/2 && 
            point[1] <= this.point[1] && 
            point[1] >= (this.point[1] - this.bounds[1])) {
                return this.id;
        }

        return false;
    }

    isUnderSelection(bounds) {
        let topLeft = [this.point[0] - this.bounds[0]/2, this.point[1] - this.bounds[1]];
        let bottomRight = [this.point[0] + this.bounds[0]/2, this.point[1] + this.bounds[1]];
        return Coords.inRect(topLeft, bounds) && Coords.inRect(bottomRight, bounds);
    }

    isHoverPoint(p, props) {
        return false;
    }

    getMoveableProps() {
        return [this.point];
    }

    relativeMove(point, origin, initialState) {
        let dx = point[0] - origin[0];
        let dy = point[1] - origin[1];

        this.updateProp('point', [initialState[0][0] + dx, initialState[0][1] + dy]);
    }

    draw(props) {
        let point = Coords.toView(this.point, props.viewCenter, props.lookingAt, props.tileSize);

        this.ctx.fillStyle = this.props.color;
        this.ctx.font = '18px sans-serif';
        this.ctx.textAlign = "center";

        this.bounds = [(this.ctx.measureText(this.props.text).width + 6) / props.tileSize, 23 / props.tileSize];

        if (props.hover) {
            this.ctx.strokeStyle = '#0ff';
            let bounds = [this.bounds[0]*props.tileSize, this.bounds[1]*props.tileSize];
            this.ctx.strokeRect(point[0] - bounds[0]/2, point[1] - bounds[1] + 6, bounds[0], bounds[1]);
        }

        this.ctx.strokeStyle = '#000';
        this.ctx.lineWidth = 3;

        this.ctx.beginPath();
        this.ctx.strokeText(this.props.text, point[0], point[1]);
        this.ctx.fillText(this.props.text, point[0], point[1]);
    }

}